import React, { useState } from 'react';
import { Button, InputTextArea, Spinner, Tabs, Text } from '@spark';
import PromptTemplateEditor from './PromptTemplateEditor';
import ResponseStepCard from './ResponseStepCard';

/**
 * Compare "Input" card (Figma .ModelSetup-CompareIo): the dataset sample the
 * model runs on. "Example" shows the raw dataset row (editable); "What the
 * model receives" shows the prompt with the sample values substituted.
 */
const SampleInputStep = ({
    requestExample,
    setRequestExample,
    onShuffleExample,
    shuffleLoading,
    extraParamsValues,
    generatingResponse,
    rawResponseLoading,
    promptTemplate = '',
    hideShuffle = false,
}) => {
    const [activeTab, setActiveTab] = useState('example');
    const showReceivesTab = Boolean((promptTemplate || '').trim());
    const activeId = showReceivesTab ? activeTab : 'example';

    return (
        <ResponseStepCard
            title={<div className="fs-unmask">Input</div>}
            extra={!hideShuffle ? (
                <Button
                    type="button"
                    variant="ghost"
                    size="small"
                    startIcon={shuffleLoading ? <Spinner size="small" /> : undefined}
                    disabled={shuffleLoading}
                    onClick={onShuffleExample}
                    className="fs-unmask"
                >
                    Show another row
                </Button>
            ) : null}
        >
            {showReceivesTab && (
                <Tabs
                    size="small"
                    className="response-step-card__input-tabs fs-unmask"
                    items={[
                        { id: 'example', label: 'Example' },
                        { id: 'receives', label: 'What the model receives' },
                    ]}
                    activeId={activeId}
                    onChange={setActiveTab}
                />
            )}
            <Text variant="detail-regular" color="secondary" as="div" className="fs-unmask">
                {activeId === 'receives'
                    ? 'The whole input the model will process.'
                    : 'An example from this dataset row'}
            </Text>
            {activeId === 'receives' ? (
                <PromptTemplateEditor
                    value={promptTemplate}
                    mode="preview"
                    disabled
                    placeholder="No prompt configured yet."
                    exampleValue={requestExample || ''}
                    paramValues={extraParamsValues || {}}
                    ariaLabel="What the model receives"
                    className="response-step-card__prompt-preview"
                />
            ) : (
                <InputTextArea
                    showLabel={false}
                    value={requestExample || ''}
                    onChange={(e) => setRequestExample(e.target.value)}
                    placeholder="Add the sample text you want to test"
                    rows={6}
                    disabled={generatingResponse || rawResponseLoading}
                    className="response-step-card__sample-textarea"
                    aria-label="Sample input"
                />
            )}
        </ResponseStepCard>
    );
};

export default SampleInputStep;
